var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "20px",
    viewBox: "0 0 25 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "44BB54A9-C957-4324-AF65-936BFF5AE84F@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0103576723 15.9999805 0.0103576723 15.9999805 14.2105244 0 14.2105244"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "1.87845304e-05 0.00998392283 17 0.00998392283 17 14.9891057 1.87845304e-05 14.9891057"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coach",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-(-gym-owner-)-",
    transform: "translate(-29.000000, -441.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SIDEBAR",
    transform: "translate(-1.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main",
    transform: "translate(9.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(21.000000, 334.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9125957,0.0103576723 L2.08736492,0.0103576723 C0.933100308,0.013960341 -0.000561230769,0.966265752 -1.99277642e-05,2.13943477 L-1.99277642e-05,8.85440882 C0.000521846154,10.0225241 0.932657231,10.9690252 2.08194954,10.9684748 L2.08736492,10.9684748 L3.74151877,10.9684748 L3.74151877,13.3527409 C3.74151877,14.3159544 4.23776492,14.4945867 4.844288,13.7530374 L7.12372185,10.9684748 L13.9125957,10.9684748 C15.0619372,10.9720775 15.9964357,10.0280282 15.9999801,8.8599129 L15.9999801,8.85440882 L15.9999801,2.13943477 C16.0005218,0.966265752 15.0668603,0.013960341 13.9125957,0.0103576723",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(8.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9193558,0.00998392283 L3.0994663,0.00998392283 C1.40604088,0.00998392283 1.87845304e-05,1.42268489 1.87845304e-05,3.16191318 L1.87845304e-05,3.57911576 L6.22943867,3.57911576 C8.15485304,3.57911576 9.72101326,5.15773312 9.72101326,7.13618971 L9.72101326,12.3090193 L11.5440519,12.3090193 L13.3755436,14.5522669 C13.9564552,15.2636817 14.4293088,15.0876367 14.4260685,14.1591801 L14.4171459,12.271881 C15.8762343,12.017701 17.0000188,10.6696302 17.0000188,9.10403537 L17.0000188,3.16191318 C17.0000188,1.42268489 15.6127812,0.00998392283 13.9193558,0.00998392283",
    id: "Fill-4",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.ca1ff5c382b1fa673e19900b1ad15890.svg";
export { ForwardRef as ReactComponent };